class NpcAdminController {
    static $inject = ["$q", "$location", "stToast", "tpsrService"];

    constructor($q, $location, stToast, tpsrService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;

        this.originalUser = null;
        this.user = null;
        this.emailValid = true;
        this.emailValidReason = null;
    }

    $onInit() {
        if(!this.tpsr.user.is_npc_admin)
            this.$location.url(`/`);

        if (this.userId)
            return this._loadUser(this.userId);
        else
            this.user = {
                email: null,
                first_name: null,
                last_name: null,
                is_npc_admin: true
            };
    }


    createUserClicked = () => {
        return this.tpsr.getUserforEmail(this.user.email).then(result => {
            if (result.users.length) {
                this.emailValid = false;
                this.emailValidReason = "User already exists with this email";
            } else {

                const request = {
                    email: this.user.email,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,

                    is_npc_admin_bit: true,
                    is_admin_bit: false,
                    is_manager_bit: false,
                    is_approver_bit: false
                };
                return this.tpsr.insertUser(request).then(result => {
                    this.toast.success("NPC Admin Created", `NPC Admin created.`)
                    this.$location.url(`/npc-admins`);
                });

            }
        });
    };

    updateUserClicked = () => {
        const request = {
            user_id: this.user.user_id,
            email: this.user.email,
            first_name: this.user.first_name,
            last_name: this.user.last_name,

            is_npc_admin_bit: true,
            is_admin_bit: this.user.is_admin,
            is_manager_bit: this.user.is_manager,
            is_approver_bit: this.user.is_approver
        };
        return this.tpsr.updateUser(request).then(result => {
            this.toast.success("NPC Admin Updated", `NPC Admin updated.`)
            this.$location.url(`/npc-admins`);
        });
    };

    cancelClicked = () => {
        this.$location.url(`/npc-admins`);
    };

    _loadUser = user_id => {
        return this.tpsr.getUser(user_id).then(result => {
            this.user = result;
            this.originalUser = angular.copy(result);
        });
    };
}

angular
    .module("app")
    .component("npcAdmin", { // npc-admin
        bindings: {
            userId: "<"
        },
        templateUrl: "src/app/npcAdmin/npcAdmin.html",
        controller: NpcAdminController
    });
